// extracted by mini-css-extract-plugin
export default {"input":"OaZq6IhwR_uBn2CPDOw0","icon":"O4CKZWjmfg0rUYT8bEt1"};